export const ROUTES = {
  HOME_PAGE: "/",
  BEST_SELLER: "/best-seller",
  NEW_IN: "/new-in",
  ON_SALE: "/black-friday",

  PRODUCT: "/product",
  PRODUCT_CATEGORY: "/product/category",

  COLLECTION: "/collection",

  // Introduce
  INTRODUCE: "/introduce",
  RECRUITMENT: "/introduce/recruitment",
  RECRUITMENT_JOB: "/introduce/recruitment/job",
  LIFE: "/introduce/recruitment/life",
  LIFE_HOT_JOB: "/introduce/recruitment/life/hot-job",
  BRANCH: "/introduce/branch",
  ABOUT_US: "/introduce/about-us",
  MEMBERSHIP: "/introduce/membership",
  FAQ: "/introduce/faq",
  POLICY_TERMS: "/introduce/policy-terms",
  POLICY_TERMS_DOMESTIC: "/introduce/policy-terms/domestic",
  POLICY_TERMS_INTERNATIONAL: "/international-policy",
  INTERNATIONAL_POLICY: "/international-policy",
  SALE_POLICY: "/sale-policy",

  EVENT: "/event",
  SEARCH: "/search",

  // Auth
  SIGN_IN: "/sign-in",
  SIGN_IN_WITH_PASSWORD: "/sign-in?tab=password",
  SIGN_UP: "/sign-up",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",

  // Cart
  CART: "/cart",
  CART_PAYMENT: "/cart/payment",
  CART_PAYMENT_ADDRESS: "/cart/payment?step=address",
  CART_PAYMENT_PAYMENT: "/cart/payment?step=payment",

  DEVICE: "/device",
  DEVICE_ORDERS: "/device/orders",
  DEVICE_ADDRESS: "/device/address",

  // Profile
  PROFILE: "/profile",
  PROFILE_ORDERS: "/profile/orders",
  PROFILE_NOTIFICATION: "/profile/notification",
  PROFILE_INFO: "/profile/info",
  PROFILE_FAVORITE_PRODUCTS: "/profile/favorite-products",
  PROFILE_ADDRESS: "/profile/address",
  PROFILE_ADDRESS_ADD: "/profile/address/add",
  PROFILE_ADDRESS_EDIT: "/profile/address/edit",
  PROFILE_VOUCHER: "/profile/wallet-voucher",

  BLOG: "/blog",
  BLOG_SEARCH: "/blog/search",

  PRIVACY_POLICY: "/chinh-sach-bao-mat",
  REFUND_POLICY: "/chinh-sach-hoan-tien",
  SHIPPING_POLICY: "/chinh-sach-van-chuyen",
  PAYMENT_METHODS: "/phuong-thuc-thanh-toan",
}


const IGNORE_META_PATH = [
  '/blog/',
  '/product/',
]
